import React from 'react';
import PropTypes from 'prop-types';

export default function When({ predicate, children }) {
  return predicate ? <>{children}</> : <></>;
}

When.defaultProps = {
  predicate: false,
};

When.propTypes = {
  predicate: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
